import Wrapper from "../layout/wrapper/Wrapper";
import styles from "../styles/pages/home-dashboard.module.scss";
// import styles from "@/styles/pages/home.module.scss";
import Box from "@mui/material/Box";
// import assest from "@/json/assest";
import assest from "../json/assest/index";
import localizedFormat from "dayjs/plugin/localizedFormat";
import {
  Button,
  Grid,
  List,
  ListItem,
  Menu,
  MenuItem,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
// import Seo from "@/components/Seo/Seo";
import Seo from "../components/Seo/Seo";
import { DatePicker } from "@imarabinda/antd";
import dayjs from "dayjs";
import useCalenderFilter from "../hooks/useCalenderFilter";
import { useAppSelector } from "../hooks/useAppSelector";
// import { closeGalleryModalSlice } from "../reduxtoolkit/slices/global.slice";
import { closeGalleryModalSlice } from "../redux-toolkit/slices/global.slice.js";
import SubmissionModal from "../components/ModalTables/Submissions/SubmissionModal";
// import ExpensesModal from "../components/ModalTables/Expenses/ExpensesModal";
// import GalleryModal from "../components/ModalTables/Gallery/GalleryModal";
// import InvitationModal from "../components/ModalTables/InvitationModal/InvitationModal";
// import AllPurchasedVideoModal from "../components/ModalTables/AllPurchasedVideos/AllPurchasedVideoModal";
// import VideoTitlingBaseModalTable from "../components/ModalTables/VideoTitling/VideoTitlingBaseModalTable";
// import VideosBaseModalTable from "../components/ModalTables/Videos/VideosBaseModalTable";
import {
  customSubmissionsList,
  submissionsList,
} from "../api/functions/cms.api";
// import { submissionsList } from "../";
import { useInfiniteQuery, useQuery } from "react-query";
import {
  PendingInvitationsList,
  customTopAcquisitorsList,
  topAcquisitorsList,
} from "../api/functions/user.api";
// import { TopAcquisitorsdata } from "@/types/common.type";
import { useAppDispatch } from "../hooks/useAppDispatch";
import InvitationModal from "../components/ModalTables/InvitationModal/InvitationModal";
import GalleryModal from "../components/ModalTables/Gallery/GalleryModal";
import DashboardApproveApproveModal from "../components/ModalTables/Videos/DashboardApproveApproveModal";
import DashboardRejectedRejectedModal from "../components/ModalTables/Videos/DashboardRejectedRejectedModal";
import DashboardWebsiteWebsiteModal from "../components/ModalTables/Videos/DashboardWebsiteWebsiteModal";
import DashboardApproveRejectedModal from "../components/ModalTables/Videos/DashboardApproveRejectedModal";
import DashboardApproveWebsiteModal from "../components/ModalTables/Videos/DashboardApproveWebsiteModal";
import DashboardRejectedApprovedModal from "../components/ModalTables/Videos/DashboardRejectedApprovedModal";
import DashboardRejectedWebsiteModal from "../components/ModalTables/Videos/DashboardRejectedWebsiteModal";
import DashboardWebsiteApprovedModal from "../components/ModalTables/Videos/DashboardWebsiteApprovedModal";
import DashboardWebsiteRejectedModal from "../components/ModalTables/Videos/DashboardWebsiteRejectedModal";
import DashboardUnreachableModal from "../components/ModalTables/Videos/DashboardUnreachableModal";
import DashboardTitledModal from "../components/ModalTables/Videos/DashboardTitledModal";
import DashboardUntitledModal from "../components/ModalTables/Videos/DashboardUntitledModal";
import DashBoardRevisedTitlesPendingModal from "../components/ModalTables/Videos/DashBoardRevisedTitlesPendingModal";
import ExpensesBreakdown from "../components/Dashboard/ExpensesBreakdown";
import TopAcquisitors from "../components/Dashboard/TopAcquisitors";
import ApiLoader from "../components/Loaders/ApiLoader";
import DashboardVideoPendingPublicationModal from "../components/ModalTables/Videos/DashboardVideoPendingPublicationModal";
import DashboardTitledRevisedModal from "../components/ModalTables/Videos/DashboardTitledRevisedModal";
import PurchasedVideoModal from "../components/ModalTables/AllPurchasedVideos/PurchasedVideoModal";
import CalenderDate from "./Calender";
import {
  concatHostAndImagePath,
  emptyHandleTwo,
} from "../lib/functions/utils.lib";
import InfiniteScroll from "react-infinite-scroll-component";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useInView } from "react-intersection-observer";
// import SubmissionModal from "../components/ModalTables/Submissions/SubmissionModal";
// import SinglePurchasedVideoTableData from "@/components/ModalTables/AllPurchasedVideos/Fragments/SinglePurchasedVideoTableData";
// import { useOnClickOutside } from "usehooks-ts";
const acordianDataPendingInvitations = [
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson",
    role: "Quality Agent",
    date: "Nov 19, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson1",
    role: "Quality Agent1",
    date: "Nov 22, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson2",
    role: "Quality Agent2",
    date: "Nov 1, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson3",
    role: "Quality Agent3",
    date: "Nov 2, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson4",
    role: "Quality Agent4",
    date: "Nov 3, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson5",
    role: "Quality Agent5",
    date: "Nov 4, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson6",
    role: "Quality Agent6",
    date: "Nov 5, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson7",
    role: "Quality Agent7",
    date: "Nov 6, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson8",
    role: "Quality Agent8",
    date: "Nov 7, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson9",
    role: "Quality Agent9",
    date: "Nov 8, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson10",
    role: "Quality Agent10",
    date: "Nov 9, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson11",
    role: "Quality Agent11",
    date: "Nov 11, 2022",
  },

  {
    img: assest.profileIcon,
    title: " Saimon Jhonson12",
    role: "Quality Agent12",
    date: "Nov 10, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson13",
    role: "Quality Agent13",
    date: "Nov 12, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson14",
    role: "Quality Agent14",
    date: "Nov 13, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson15",
    role: "Quality Agent15",
    date: "Nov 14, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson16",
    role: "Quality Agent16",
    date: "Nov 15, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson17",
    role: "Quality Agent17",
    date: "Nov 16, 2022",
  },
  {
    img: assest.profileIcon,
    title: " Saimon Jhonson18",
    role: "Quality Agent18",
    date: "Nov 17, 2022",
  },
];

dayjs.extend(localizedFormat);

const { RangePicker } = DatePicker;

export default function Home() {
  //toggles
  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const [openThisYear, setOpenThisYear] = React.useState(false);
  const handleToggleThisYear = () => {
    setOpenThisYear(!openThisYear);
    setOpenPendingInvitationSeeAll(false);
    setOpenTopApproved(false);
  };
  const [openTopApproved, setOpenTopApproved] = React.useState(false);
  const handleToggleTopApproved = () => {
    setOpenTopApproved(!openTopApproved);
    setOpenThisYear(false);
    setOpenPendingInvitationSeeAll(false);
  };
  const [openPendingInvitationSeeAll, setOpenPendingInvitationSeeAll] =
    React.useState(false);
  const handleTogglePendingInvitationSeeAll = () => {
    setOpenPendingInvitationSeeAll(!openPendingInvitationSeeAll);
    setOpenThisYear(false);
    setOpenTopApproved(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        // The click is outside the component, handle the logic here
        setOpenTopApproved(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside1 = (event) => {
      if (ref1.current && !ref1.current.contains(event.target)) {
        // The click is outside the component, handle the logic here
        // setOpenTopApproved(!openTopApproved);
        setOpenThisYear(false);
      }
    };

    document.addEventListener("click", handleClickOutside1);

    return () => {
      document.removeEventListener("click", handleClickOutside1);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (ref2.current && !ref2.current.contains(event.target)) {
        // The click is outside the component, handle the logic here
        // setOpenTopApproved(!openTopApproved);
        setOpenPendingInvitationSeeAll(false);
      }
    };

    document.addEventListener("click", handleClickOutside2);

    return () => {
      document.removeEventListener("click", handleClickOutside2);
    };
  }, []);

  const [showMore, setShowMore] = useState(false);
  const [showMore1, setShowMore1] = useState(false);

  //video modal states
  const [openApprovedModal, setOpenApprovedModal] = useState(false);
  const handleOpenApprovedModal = useCallback(() => {
    setOpenApprovedModal(true);
  }, []);
  const handleCloseApprovedModal = useCallback(() => {
    setOpenApprovedModal(false);
  }, []);

  const [openRejectedModal, setOpenRejectedModal] = useState(false);
  const handleOpenRejectedModal = useCallback(() => {
    setOpenRejectedModal(true);
  }, []);

  const handleCloseRejectedModal = useCallback(() => {
    setOpenRejectedModal(false);
  }, []);

  const [openWebsiteModal, setOpenWebsiteModal] = useState(false);
  const handleOpenWebsiteModal = useCallback(() => {
    setOpenWebsiteModal(true);
  }, []);
  const handleCloseWebsiteModal = useCallback(() => {
    setOpenWebsiteModal(false);
  }, []);

  const [openApproveRejectModal, setOpenApproveRejectModal] = useState(false);
  const handleOpenApproveRejectModal = useCallback(() => {
    setOpenApproveRejectModal(true);
  }, []);
  const handleCloseApproveRejectModal = useCallback(() => {
    setOpenApproveRejectModal(false);
  }, []);

  const [openApproveWebsiteOnlyModal, setOpenApproveWebsiteOnlyModal] =
    useState(false);
  const handleOpenApproveWebsiteOnlyModal = useCallback(() => {
    setOpenApproveWebsiteOnlyModal(true);
  }, []);
  const handleCloseApproveWebsiteOnlyModal = useCallback(() => {
    setOpenApproveWebsiteOnlyModal(false);
  }, []);

  const [openRejectedApproveModal, setOpenRejectedApproveModal] =
    useState(false);
  const handleOpenRejectedApproveModal = useCallback(() => {
    setOpenRejectedApproveModal(true);
  }, []);
  const handleCloseRejectedApproveModal = useCallback(() => {
    setOpenRejectedApproveModal(false);
  }, []);

  const [openRejectedWebModal, setOpenRejectedWebModal] = useState(false);
  const handleOpenRejectedWebModal = useCallback(() => {
    setOpenRejectedWebModal(true);
  }, []);
  const handleCloseRejectedWebModal = useCallback(() => {
    setOpenRejectedWebModal(false);
  }, []);

  const [openWebApprovedModal, setOpenWebApprovedModal] = useState(false);
  const handleOpenWebApprovedModal = useCallback(() => {
    setOpenWebApprovedModal(true);
  }, []);
  const handleCloseWebApprovedModal = useCallback(() => {
    setOpenWebApprovedModal(false);
  }, []);

  const [openWebRejectedModal, setOpenWebRejectedModal] = useState(false);
  const handleOpenWebRejectedModal = useCallback(() => {
    setOpenWebRejectedModal(true);
  }, []);
  const handleCloseWebRejectedModal = useCallback(() => {
    setOpenWebRejectedModal(false);
  }, []);

  //video titling
  const [openUntitledVideoModal, setOpenUntitledVideoModal] = useState(false);
  const handleOpenUntitledVideoModal = useCallback(() => {
    setOpenUntitledVideoModal(true);
  }, []);
  const handleCloseUntitledVideoModal = useCallback(() => {
    setOpenUntitledVideoModal(false);
  }, []);

  const [openTitledVideoModal, setOpenTitledVideoModal] = useState(false);
  const handleOpenTitledVideoModal = useCallback(() => {
    setOpenTitledVideoModal(true);
  }, []);
  const handleCloseTitledVideoModal = useCallback(() => {
    setOpenTitledVideoModal(false);
  }, []);

  const [openRevisedTitleModal, setOpenRevisedTitleModal] = useState(false);
  const handleOpenRevisedTitleModal = useCallback(() => {
    setOpenRevisedTitleModal(true);
  }, []);
  const handleCloseRevisedTitleModal = useCallback(() => {
    setOpenRevisedTitleModal(false);
  }, []);

  const [openPendingRevisionModal, setOpenPendingRevisionModal] =
    useState(false);
  const handleOpenPendingRevisionModal = useCallback(() => {
    setOpenPendingRevisionModal(true);
  }, []);
  const handleClosePendingRevisionModal = useCallback(() => {
    setOpenPendingRevisionModal(false);
  }, []);

  const [openPendingPublicationModal, setOpenPendingPublicationModal] =
    useState(false);
  const handleClosePendingPublicationModal = useCallback(() => {
    setOpenPendingPublicationModal(false);
  }, []);
  const handleOpenPendingPublicationModal = useCallback(() => {
    setOpenPendingPublicationModal(true);
  }, []);

  //expense modal states
  const [openExpensesModal, setOpenExpensesModal] = useState(false);
  const handleOpenExpensesModal = useCallback(() => {
    setOpenExpensesModal(true);
  }, []);
  const handleCloseExpensesModal = useCallback(() => {
    setOpenExpensesModal(false);
  }, []);

  //submission modal states
  const [openSubmissionModal, setOpenSubmissionModal] = useState(false);
  const handleOpenSubmissionModal = useCallback(() => {
    setOpenSubmissionModal(true);
  }, []);
  const handleCloseSubmissionModal = useCallback(() => {
    setOpenSubmissionModal(false);
  }, []);

  //gallery modal state
  const { openedGalleryModal } = useAppSelector((state) => state.globalSlice);
  const dispatch = useAppDispatch();
  const handleCloseGalleryModal = useCallback(() => {
    dispatch(closeGalleryModalSlice());
  }, []);

  //invitation modal state
  const [invitationData, setInvitationData] = React.useState();
  const [openInvitationModal, setOpenInvitationModal] = React.useState(false);
  const handleOpenInvitationModal = useCallback((data) => {
    setInvitationData(data);
    setOpenInvitationModal(true);
  }, []);
  const handleCloseInvitationModal = useCallback(() => {
    setOpenInvitationModal(false);
  }, []);

  //purchase modal states
  const [value, setValue] = React.useState(0);
  const [openAllPurchasedVideoModal, setOpenAllPurchasedModal] =
    useState(false);
  const handleOpenAllPurchasedVideoModal = useCallback((index) => {
    setOpenAllPurchasedModal(true);
    setValue(index);
  }, []);
  const handleCloseAllPurchasedVideoModal = useCallback(() => {
    setOpenAllPurchasedModal(false);
  }, []);

  //calender functions
  const calenderId = "calendar-input-home";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    calenderOpen,
    resetCalender,
    confirmCalender,
    confirmedCalenderValue,
    calenderValue,
    setCalenderValue,
    toggleCalender,
    closeCalender,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderId,
  });

  // const { data: submission } = useQuery(["submissionsList"], submissionsList);
  // console.log("submission", submission);
  // const { data: topAcquisitor } = useQuery(
  //   ["topAcquisitorsList"],
  //   topAcquisitorsList
  // );

  // console.log('topAcquisitor', topAcquisitor)

  /*   const { data: PendingInvitations } = useQuery(
    ["PendingInvitationsList"],
    PendingInvitationsList
  );

  console.log("PendingInvitations", PendingInvitations); */

  const { data, fetchNextPage, hasNextPage, refetch } = useInfiniteQuery({
    queryKey: ["PendingInvitationsList"],
    queryFn: ({ pageParam = 1 }) => {
      // console.log(pageParam, "pageParam");
      return PendingInvitationsList(pageParam);
    },
    keepPreviousData: true,

    enabled: true,

    getNextPageParam: (lastPage, allPages) => {
      if (
        allPages[allPages.length - 1 || 0]?.current_page <
        allPages[0]?.last_page
      ) {
        return allPages[allPages.length - 1 || 0]?.current_page + 1;
      } else {
        return undefined;
      }
    },
  });
  // console.log("data", data);
  const PendingInvitations = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat?.data, ...item.data] };
    });
    return dat;
  }, [data]);
  // console.log("PendingInvitations", PendingInvitations);

  const formatDate = (inputDateStr) => {
    const inputDate = new Date(inputDateStr);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return inputDate.toLocaleDateString(undefined, options);
  };

  // const { submission } = useAppSelector((state) => state.appStateSlice);
  const filteredDate = useMemo(() => {
    const selectedDate =
      calenderValue &&
      calenderValue?.length > 0 &&
      calenderValue?.map((_d) => _d.format("YYYY-MM-DD"));
    // calenderValue?.map((_d) => new Date(_d).toISOString().slice(0, 10));
    return (
      selectedDate &&
      selectedDate?.length > 0 && {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        type: calenderFilter?.name,
      }
    );
  }, [calenderValue]);
  const { data: submission, isLoading } = useQuery(
    ["customSubmissionsList", filteredDate],
    (body) => customSubmissionsList(body, filteredDate),
    { enabled: !!filteredDate }
  );
  /* const { data: topAcquisitor, isLoading: topAcquisitorLoading } = useQuery(
    ["customTopAcquisitorsList", filteredDate],
    () => customTopAcquisitorsList(filteredDate),
    { enabled: !!filteredDate }
  ); */

  const { ref: paymentInvitationRef, inView } = useInView({
    threshold: 0,
  });

  // console.log("calenderValue", filteredDate, calenderFilter?.name);
  return (
    <Wrapper>
      {/* <Seo title="Home" canonical={""} description={""} url={""} img={""} /> */}
      {isLoading ? (
        <ApiLoader loading={isLoading} />
      ) : (
        <Box className="main_body">
          {/* <Box className="scrollHome"> */}
          <Box className={styles.dashboardWrapper}>
            <Box className={styles.dashboardBodyScroll}>
              <Box
                className={`${styles.cmn_box_dashwrap} commonBox commonBoxHome`}
              >
                <Box className="commonSearchBar">
                  <Box className="showimg_data">
                    <Box className="showimg_data_text">
                      <span className={styles.showing_data_for}>
                        Showing Data for
                      </span>
                      {calenderFilter ? (
                        <>
                          <Box
                            className={`dayList ${
                              openedDateRangeFilter ? "date-black" : "date-blue"
                            }`}
                          >
                            <Button onClick={handleOpenDateRangeFilter}>
                              {calenderFilter?.name}
                            </Button>
                            <Menu
                              anchorEl={dateRangeFilterAnchor}
                              open={openedDateRangeFilter}
                              onClose={handleCloseDateRangeFilter}
                              className={`${styles.dateList_new} dateList`}
                            >
                              {/* {DateFilterRangeList.slice(1).map((filter) => (
                                <MenuItem
                                  onClick={changeCalenderFilter(filter)}
                                  key={filter.name}
                                  selected={filter === calenderFilter}
                                >
                                  {filter.name}
                                </MenuItem>
                              ))} */}
                              {DateFilterRangeList.map((filter) => {
                                if (filter != calenderFilter) {
                                  return (
                                    <MenuItem
                                      onClick={changeCalenderFilter(filter)}
                                      key={filter.name}
                                      selected={filter === calenderFilter}
                                    >
                                      {filter.name}
                                    </MenuItem>
                                  );
                                }
                              })}
                            </Menu>
                          </Box>
                          <span className="dateList">
                            ({calenderFilterShowValue})
                          </span>
                        </>
                      ) : (
                        <>
                          the period from{" "}
                          {confirmedCalenderValue?.[0] ? (
                            <span className="dayList">
                              {dayjs(confirmedCalenderValue?.[0]).format("LL")}
                            </span>
                          ) : null}
                          to{" "}
                          {calenderValue?.[1] ? (
                            <span className="dayList">
                              {dayjs(confirmedCalenderValue?.[1]).format("LL")}
                            </span>
                          ) : null}
                        </>
                      )}
                    </Box>
                    {calenderFilter?.name !== "All time" ? (
                      <span className="reset_picker" onClick={resetCalender}>
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                            stroke="currentColor"
                            strokeLinecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M4.22705 6.7832L6.77263 4.23762"
                            stroke="currentColor"
                            strokeWidth="0.8"
                            strokeLinecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M6.77263 6.76238L4.22705 4.2168"
                            stroke="currentColor"
                            strokeWidth="0.8"
                            strokeLinecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        reset
                      </span>
                    ) : null}
                  </Box>

                  {/* <div
                    id={calenderId}
                    style={{
                      opacity: 0,
                      visibility: "hidden",
                      position: "absolute",
                      right: "5%",
                    }}
                  >
                    <RangePicker
                      value={calenderValue}
                      open={calenderOpen}
                      onCalendarChange={(val) => {
                        setCalenderValue(val);
                      }}
                      renderExtraFooter={() => (
                        <Stack direction="row" justifyContent={"flex-end"}>
                          <Button onClick={closeCalender}>Cancel</Button>
                          <Button onClick={confirmCalender} className="active">
                            Confirm
                          </Button>
                        </Stack>
                      )}
                    />
                  </div>

                  <Button onClick={toggleCalender} className="calenderButton">
                    <img
                      src={assest.calendar_black}
                      width={17}
                      height={19}
                      alt=""
                    />
                  </Button> */}
                  <CalenderDate confirmCalender={confirmCalenderTwo} />
                </Box>

                <Grid container spacing={3}>
                  <Grid item lg={4} md={6} sm={12}>
                    <Box
                      className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxTop} ${styles.homeSubmmisionBox}`}
                    >
                      <Box
                        className={`commonSmallBox ${styles.submissionVideoBox}`}
                      >
                        <Box className={styles.commonSmallBox}>
                          <Box className={styles.infoTable}>
                            <Box className={styles.infoTable_head}>
                              <Link href="">
                                <Box className={styles.tble_hdng}>
                                  All Submissions
                                </Box>
                                <Box className={styles.tble_hdng}>
                                  {emptyHandleTwo(
                                    submission?.data?.all_submissions?.total
                                  )}
                                </Box>
                              </Link>
                            </Box>

                            <Box className={styles.infoTble_body}>
                              <Box className={styles.infoTble_row}>
                                <Link to="/approved">
                                  <Box className={styles.infoTble_cell}>
                                    Approved
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        ?.approved
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link to="/rejected">
                                  <Box className={styles.infoTble_cell}>
                                    Rejected
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        ?.rejected
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link to="/website">
                                  <Box className={styles.infoTble_cell}>
                                    Website Only
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        ?.website_only
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    Awaiting Confirmation
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        ?.awaiting_confirmation
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link to="/duplications">
                                  <Box className={styles.infoTble_cell}>
                                    Duplicates
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        .duplicate_videos
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box
                                className={styles.infoTble_row}
                                onClick={handleOpenSubmissionModal}
                              >
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    Unreachable Submitters
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.all_submissions
                                        .unreachable_submitters
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={12}>
                    <Box
                      className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxTop}`}
                    >
                      <Box
                        className={`commonSmallBox ${styles.submissionVideoBox}`}
                      >
                        <Box className={styles.commonSmallBox}>
                          <Box className={styles.infoTable}>
                            <Box className={styles.infoTable_head}>
                              <Link href="">
                                <Box className={styles.tble_hdng}>
                                  Confirmed Videos
                                </Box>
                                <Box className={styles.tble_hdng}>
                                  {emptyHandleTwo(
                                    submission?.data?.confirmed_videos.total
                                  )}
                                </Box>
                              </Link>
                            </Box>

                            <Box className={styles.infoTble_body}>
                              <Box
                                className={styles.infoTble_row}
                                onClick={handleOpenApprovedModal}
                              >
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Approved</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Approved</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.confirmed_videos
                                        .approved_approved
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box
                                className={styles.infoTble_row}
                                onClick={handleOpenRejectedModal}
                              >
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Rejected</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Rejected</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.confirmed_videos
                                        .rejected_rejected
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box
                                className={styles.infoTble_row}
                                onClick={handleOpenWebsiteModal}
                              >
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Website Only</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Website Only</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.confirmed_videos?.[
                                        "website_&_website"
                                      ]
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={12}>
                    <Box
                      className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxTop}`}
                    >
                      <Box
                        className={`commonSmallBox ${styles.submissionVideoBox}`}
                      >
                        <Box className={styles.commonSmallBox}>
                          <Box className={styles.infoTable}>
                            <Box className={styles.infoTable_head}>
                              <Link href="">
                                <Box className={styles.tble_hdng}>
                                  Denied Videos
                                </Box>
                                <Box className={styles.tble_hdng}>
                                  {emptyHandleTwo(
                                    submission?.data?.denied.total
                                  )}
                                </Box>
                              </Link>
                            </Box>

                            <Box className={styles.infoTble_body}>
                              <Box
                                className={styles.infoTble_row}
                                onClick={handleOpenApproveRejectModal}
                              >
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Approved</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Rejected</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.approved_rejected
                                    )}
                                  </Box>
                                </Link>
                              </Box>

                              <Box className={styles.infoTble_row}>
                                <Link
                                  href=""
                                  onClick={handleOpenApproveWebsiteOnlyModal}
                                >
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Approved</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Website Only</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.approved_website
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link
                                  href=""
                                  onClick={handleOpenRejectedApproveModal}
                                >
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Rejected</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Approved</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.rejected_approved
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link
                                  href=""
                                  onClick={handleOpenRejectedWebModal}
                                >
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Rejected</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Website Only</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.rejected_website
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link
                                  href=""
                                  onClick={handleOpenWebApprovedModal}
                                >
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Website Only</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Approved</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.website_approved
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link
                                  href=""
                                  onClick={handleOpenWebRejectedModal}
                                >
                                  <Box className={styles.infoTble_cell}>
                                    <Box className={styles.tble_innrWrp}>
                                      <span>Website Only</span>
                                      <img
                                        src={assest.arrowIcon}
                                        className={styles.arricn}
                                        width={53}
                                        height={3}
                                        alt=""
                                      />
                                      <span>Rejected</span>
                                    </Box>
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    {emptyHandleTwo(
                                      submission?.data?.denied.website_rejected
                                    )}
                                  </Box>
                                </Link>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    lg={11}
                    md={12}
                    className={styles.boxDownSectionHome}
                  >
                    <Box className={`${styles.boxDownSection}`}>
                      <Grid container spacing={3}>
                        <Grid
                          item
                          lg={3.9}
                          md={6}
                          sm={12}
                          className={styles.custom_grid}
                        >
                          <Box className={styles.homePendingSubmissionBox}>
                            <Box className={styles.homePendingSubmission}>
                              <Link>
                                <p>
                                  Pending Submissions <span>1200</span>
                                </p>
                              </Link>
                            </Box>
                          </Box>

                          <Box
                            className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxBtm} ${styles.VideoPublishingSummary}`}
                          >
                            <Box
                              className={`commonSmallBox ${styles.summeryBox}`}
                            >
                              <Box className={styles.commonSmallBox}>
                                <Box
                                  className={`${styles.infoTable} ${styles.infoTbleBodyHomePending}`}
                                >
                                  <Box className={styles.infoTable_head}>
                                    <Link href="">
                                      <Box className={styles.tble_hdng}>
                                        Video Publishing Summary
                                      </Box>
                                    </Link>
                                  </Box>

                                  <Box className={`${styles.infoTble_body}`}>
                                    <Box className={styles.infoTble_row}>
                                      <Link to="/published">
                                        <Box className={styles.infoTble_cell}>
                                          Published videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_publishing
                                              ?.published
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link
                                        href=""
                                        onClick={
                                          handleOpenPendingPublicationModal
                                        }
                                      >
                                        <Box className={styles.infoTble_cell}>
                                          Videos pending publication
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_publishing
                                              ?.pending
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link to="/release-video">
                                        <Box className={styles.infoTble_cell}>
                                          Released videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_publishing
                                              ?.released
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid
                          item
                          lg={3.9}
                          md={6}
                          sm={12}
                          className={styles.custom_grid}
                        >
                          <Box
                            className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxBtm}`}
                          >
                            <Box
                              className={`commonSmallBox ${styles.summeryBox}`}
                            >
                              <Box className={styles.commonSmallBox}>
                                <Box className={styles.infoTable}>
                                  <Box className={styles.infoTable_head}>
                                    <Link href="">
                                      <Box className={styles.tble_hdng}>
                                        Video Titling Summary
                                      </Box>
                                    </Link>
                                  </Box>

                                  <Box className={styles.infoTble_body}>
                                    <Box className={styles.infoTble_row}>
                                      <Link
                                        href=""
                                        onClick={handleOpenTitledVideoModal}
                                      >
                                        <Box className={styles.infoTble_cell}>
                                          Titled videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_titling
                                              .titled_video
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link
                                        href=""
                                        onClick={handleOpenUntitledVideoModal}
                                      >
                                        <Box className={styles.infoTble_cell}>
                                          Untitled videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_titling
                                              .untitled_video
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link
                                        href=""
                                        onClick={handleOpenRevisedTitleModal}
                                      >
                                        <Box className={styles.infoTble_cell}>
                                          Revised titles
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_titling
                                              .revised_title
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link href="">
                                        <Box className={styles.infoTble_cell}>
                                          Revision requests
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_titling
                                              .revesion_request
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link
                                        href=""
                                        onClick={handleOpenPendingRevisionModal}
                                      >
                                        <Box className={styles.infoTble_cell}>
                                          Pending Revision
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.video_titling
                                              .pending_revesion
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          lg={3.9}
                          md={6}
                          sm={12}
                          className={styles.custom_grid}
                        >
                          <Box
                            className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxBtm}`}
                          >
                            <Box
                              className={`commonSmallBox ${styles.summeryBox}`}
                            >
                              <Box className={styles.commonSmallBox}>
                                <Box className={styles.infoTable}>
                                  <Box className={styles.infoTable_head}>
                                    <Link href="">
                                      <Box className={styles.tble_hdng}>
                                        Purchases Summary
                                      </Box>
                                    </Link>
                                  </Box>

                                  <Box className={styles.infoTble_body}>
                                    {/* <Box className={styles.infoTble_row}>
                                      <Box className={styles.infoTble_cell}>
                                        Pending purchase requests
                                      </Box>
                                      <Box className={styles.infoTble_cell}>
                                        {
                                          submission?.data?.purchases_summary
                                            .all_videos
                                        }
                                      </Box>
                                    </Box> */}
                                    <Box
                                      // onClick={handleOpenAllPurchasedVideoModal}
                                      className={styles.infoTble_row}
                                    >
                                      <Link href="">
                                        <Box className={styles.infoTble_cell}>
                                          All videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.purchases_summary
                                              .website_only_videos
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box
                                      onClick={() =>
                                        handleOpenAllPurchasedVideoModal(1)
                                      }
                                      className={styles.infoTble_row}
                                    >
                                      <Link href="">
                                        <Box className={styles.infoTble_cell}>
                                          Website-only videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.purchases_summary
                                              .all_platform_videos
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box
                                      onClick={() =>
                                        handleOpenAllPurchasedVideoModal(0)
                                      }
                                      className={styles.infoTble_row}
                                    >
                                      <Link href="">
                                        <Box className={styles.infoTble_cell}>
                                          All-platform videos
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {emptyHandleTwo(
                                            submission?.data?.purchases_summary
                                              .total_purchases
                                          )}
                                        </Box>
                                      </Link>
                                    </Box>
                                    <Box className={styles.infoTble_row}>
                                      <Link href="">
                                        <Box className={styles.infoTble_cell}>
                                          Total purchases
                                        </Box>
                                        <Box className={styles.infoTble_cell}>
                                          {submission?.data?.purchases_summary
                                            .total_purchases
                                            ? `$${submission?.data?.purchases_summary.total_purchases}`
                                            : "-"}
                                        </Box>
                                      </Link>
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box className="commonBox commonBoxHome">
                <Grid container spacing={3}>
                  <Grid item xs={3.94}>
                    <Box
                      className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxWrapper2}`}
                    >
                      {/* <----------------------------- EXPENSE BREAKDOWN SECTION -----------------------------> */}
                      <ExpensesBreakdown ref1={ref1} />

                      <Box
                        className={`${styles.full_commonSmallBox} commonSmallBox commonBoxMessage`}
                      >
                        <Box className={`${styles.commonSmallBox}`}>
                          <Box className={styles.infoTable}>
                            <Box className={styles.infoTable_head}>
                              <Link href="">
                                <Box className={styles.tble_hdng}>
                                  Pending Messages
                                </Box>
                              </Link>
                            </Box>

                            <Box className={styles.infoTble_body}>
                              <Box className={styles.infoTble_row}>
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    Team messages
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    200
                                  </Box>
                                </Link>
                              </Box>
                              <Box className={styles.infoTble_row}>
                                <Link href="">
                                  <Box className={styles.infoTble_cell}>
                                    Support tickets
                                  </Box>
                                  <Box className={styles.infoTble_cell}>
                                    200
                                  </Box>
                                </Link>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  {/* <-----------------------------  TOP ACQUISITORS -----------------------------> */}
                  <TopAcquisitors
                    // topAcquisitor={topAcquisitor}
                    handleToggleTopApproved={handleToggleTopApproved}
                    openTopApproved={openTopApproved}
                    showMore1={showMore1}
                    filteredDate={filteredDate}
                    ref={ref}
                  />
                  <Grid item xs={4}>
                    <Box
                      className={`${styles.commonSmallBoxWrapper} ${styles.commonSmallBoxWrapper2}`}
                    >
                      <Box className="commonSmallBox commonBoxExpenses">
                        <Box
                          className={`${styles.commonSmallBox} ${styles.commonSmallBox2}`}
                        >
                          <Box
                            className={`${styles.infoTable} ${styles.infoTableInvitation}`}
                          >
                            <Box
                              className={`${styles.infoTable_head} ${styles.infoTable_headFirst}`}
                            >
                              <Link
                                href=""
                                className={styles.topAcquisitorsHead}
                              >
                                <Box className={styles.tble_hdng}>
                                  Pending Invitations
                                </Box>
                                <Box
                                  className={`${styles.tble_hdng} ${styles.tblehdngLast}`}
                                >
                                  <Button
                                    ref={ref2}
                                    id="basic-button"
                                    // onClick={
                                    //   handleTogglePendingInvitationSeeAll
                                    // }
                                    className={`${
                                      openPendingInvitationSeeAll
                                        ? styles.active_drop
                                        : null
                                    }`}
                                    endIcon={<KeyboardArrowRightIcon />}
                                  >
                                    See All{" "}
                                    {openPendingInvitationSeeAll ? (
                                      <img
                                        src={assest.upArrow}
                                        width={7}
                                        height={10}
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        src={assest.downArrow}
                                        width={7}
                                        height={10}
                                        alt=""
                                      />
                                    )}
                                  </Button>
                                  {/* {openPendingInvitationSeeAll ? (
                                    <Box className={styles.year_drop}>
                                      <ul>w
                                        <li>See all</li>
                                      </ul>
                                    </Box>
                                  ) : null} */}
                                </Box>
                              </Link>
                            </Box>

                            <Box className={styles.infoTble_body}>
                              <Box className={styles.topAcquisitorsBody}>
                                <Box className={styles.invtn_crdRow_wrppr}>
                                  {/* <Box className={styles.invtn_crdRow}>
                                    <Link
                                      href="#url"
                                      className={styles.indvdl_invtnCrd}
                                      onClick={handleOpenInvitationModal}
                                    >
                                      <Box className={styles.invtn_avatr}>
                                        <img
                                          src={assest.profileIcon}
                                          width={44}
                                          height={44}
                                          alt=""
                                        />
                                      </Box>
                                      <Box className={styles.invtn_avatrInfo}>
                                        <Box className={styles.invtn_txt}>
                                          <p>
                                            Saimon Jhonson{" "}
                                            <span>Quality Agent</span>
                                          </p>
                                          <span className={styles.invtn_sttus}>
                                            Sent on: Nov 17, 2022
                                          </span>
                                        </Box>
                                        <Box className={styles.invtnBttn}>
                                          <img
                                            src={assest.rightArrow}
                                            width={6}
                                            height={6}
                                            alt=""
                                          />
                                        </Box>
                                      </Box>
                                    </Link>
                                  </Box> */}
                                  <InfiniteScroll
                                    dataLength={
                                      PendingInvitations?.data?.length
                                    }
                                    next={fetchNextPage}
                                    height={`calc(100vh - 375px)`}
                                    hasMore={hasNextPage}
                                    loader={<h4>Loading...</h4>}
                                    className={styles.infiniteScrollInvitation}
                                  >
                                    {PendingInvitations?.data?.map(
                                      (item, index) => (
                                        <Box
                                          className={styles.invtn_crdRow}
                                          key={index}
                                        >
                                          <Link
                                            href="#url"
                                            className={styles.indvdl_invtnCrd}
                                            onClick={() =>
                                              handleOpenInvitationModal(item)
                                            }
                                          >
                                            <Box className={styles.invtn_avatr}>
                                              {item?.avatar ===
                                              "users/default.png" ? (
                                                <img
                                                  src={assest.profileIcon}
                                                  width={44}
                                                  height={44}
                                                  alt=""
                                                />
                                              ) : (
                                                <img
                                                  // src={assest.profileIcon}
                                                  src={concatHostAndImagePath(
                                                    item?.avatar
                                                  )}
                                                  width={44}
                                                  height={44}
                                                  alt=""
                                                />
                                              )}
                                            </Box>
                                            <Box
                                              className={styles.invtn_avatrInfo}
                                            >
                                              <Box className={styles.invtn_txt}>
                                                <p>
                                                  {`${item?.name} ${item?.last_name}`}{" "}
                                                  <span>
                                                    {item?.role?.display_name}
                                                  </span>
                                                </p>
                                                <span
                                                  className={styles.invtn_sttus}
                                                >
                                                  Sent on:{" "}
                                                  {formatDate(item?.created_at)}
                                                </span>
                                              </Box>
                                              <Box className={styles.invtnBttn}>
                                                <img
                                                  src={assest.rightArrow}
                                                  width={6}
                                                  height={6}
                                                  alt=""
                                                />
                                              </Box>
                                            </Box>
                                          </Link>
                                          <div
                                            ref={paymentInvitationRef}
                                            className="inview-block"
                                          ></div>
                                        </Box>
                                      )
                                    )}
                                  </InfiniteScroll>
                                </Box>
                              </Box>
                              <Box className={styles.list_btn_area}>
                                {!hasNextPage && inView && (
                                  <Button
                                    className={styles.end_list_btn}
                                    // onClick={() => setShowMore(!showMore)}
                                  >
                                    {/* {showMore ? "Show less." : "End of list."} */}
                                    End of list.
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            {/* </Box> */}
          </Box>
        </Box>
      )}

      <DashboardApproveApproveModal
        open={openApprovedModal}
        enable={openApprovedModal}
        modalHeaderProps={{
          fromStatus: "Approved",
          toStatus: "Approved",
        }}
        tableDataProps={{
          approvedByColName: "Approved by",
          confirmedByColName: "Confirmed by",
        }}
        onClose={handleCloseApprovedModal}
      />
      <DashboardRejectedRejectedModal
        open={openRejectedModal}
        enable={openRejectedModal}
        modalHeaderProps={{
          fromStatus: "Rejected",
          toStatus: "Rejected",
        }}
        tableDataProps={{
          approvedByColName: "Rejected by",
          confirmedByColName: "Confirmed by",
        }}
        onClose={handleCloseRejectedModal}
      />

      <DashboardWebsiteWebsiteModal
        open={openWebsiteModal}
        enable={openWebsiteModal}
        modalHeaderProps={{
          fromStatus: "Website only",
          toStatus: "Website only",
        }}
        tableDataProps={{
          approvedByColName: "Marked by",
          confirmedByColName: "Confirmed by",
        }}
        onClose={handleCloseWebsiteModal}
      />

      <DashboardApproveRejectedModal
        open={openApproveRejectModal}
        enable={openApproveRejectModal}
        modalHeaderProps={{
          fromStatus: "Approved",
          toStatus: "Rejected",
        }}
        tableDataProps={{
          approvedByColName: "Approved by",
          confirmedByColName: "Rejected by",
        }}
        onClose={handleCloseApproveRejectModal}
      />

      <DashboardApproveWebsiteModal
        open={openApproveWebsiteOnlyModal}
        enable={openApproveWebsiteOnlyModal}
        modalHeaderProps={{
          fromStatus: "Approved",
          toStatus: "Website only",
        }}
        tableDataProps={{
          approvedByColName: "Approved by",
          confirmedByColName: "Marked by",
        }}
        onClose={handleCloseApproveWebsiteOnlyModal}
      />

      <DashboardRejectedApprovedModal
        open={openRejectedApproveModal}
        enable={openRejectedApproveModal}
        modalHeaderProps={{
          fromStatus: "Rejected",
          toStatus: "Approved",
        }}
        tableDataProps={{
          approvedByColName: "Rejected by",
          confirmedByColName: "Approved by",
        }}
        onClose={handleCloseRejectedApproveModal}
      />

      <DashboardRejectedWebsiteModal
        open={openRejectedWebModal}
        enable={openRejectedWebModal}
        modalHeaderProps={{
          fromStatus: "Rejected",
          toStatus: "Website Only",
        }}
        tableDataProps={{
          approvedByColName: "Rejected by",
          confirmedByColName: "Marked by",
        }}
        onClose={handleCloseRejectedWebModal}
      />

      <DashboardWebsiteApprovedModal
        open={openWebApprovedModal}
        enable={openWebApprovedModal}
        modalHeaderProps={{
          fromStatus: "Website Only",
          toStatus: "Approved",
        }}
        tableDataProps={{
          approvedByColName: "Marked by",
          confirmedByColName: "Approved by",
        }}
        onClose={handleCloseWebApprovedModal}
      />

      <DashboardWebsiteRejectedModal
        open={openWebRejectedModal}
        enable={openWebRejectedModal}
        modalHeaderProps={{
          fromStatus: "Website Only",
          toStatus: "Rejected",
        }}
        tableDataProps={{
          approvedByColName: "Marked by",
          confirmedByColName: "Rejected by",
        }}
        onClose={handleCloseWebRejectedModal}
      />

      <DashboardUnreachableModal
        headerTitle="Un videos"
        open={openSubmissionModal}
        enable={openSubmissionModal}
        onClose={handleCloseSubmissionModal}
      />

      {/* <ExpensesModal
        open={openExpensesModal}
        onClose={handleCloseExpensesModal}
        selectedYearMonth={{ year: "", month: "", monthName: "" }}
      /> */}

      {/* <SubmissionModal
        open={openSubmissionModal}
        enable={openSubmissionModal}
        onClose={handleCloseSubmissionModal}
      /> */}

      <DashboardTitledModal
        headerTitle="Titled videos"
        open={openTitledVideoModal}
        enable={openTitledVideoModal}
        onClose={handleCloseTitledVideoModal}
        filterRowProps={{
          hideLastItem: true,
        }}
      />
      {/* <VideoTitlingBaseModalTable
        headerTitle="Titled videos"
        open={openTitledVideoModal}
        onClose={handleCloseTitledVideoModal}
        filterRowProps={{
          hideLastItem: true,
        }}
      /> */}
      <DashboardUntitledModal
        headerTitle="Untitled videos"
        open={openUntitledVideoModal}
        enable={openUntitledVideoModal}
        onClose={handleCloseUntitledVideoModal}
        filterRowProps={{
          hideLastItem: true,
        }}
      />

      {/* <VideoTitlingBaseModalTable
        headerTitle="Untitled videos"
        open={openUntitledVideoModal}
        onClose={handleCloseUntitledVideoModal}
        filterRowProps={{
          hideLastItem: true,
        }}
      /> */}

      {/* <VideosBaseModalTable
        open={openWebApprovedModal}
        modalHeaderProps={{
          fromStatus: "Website Only",
          toStatus: "Approved",
        }}
        tableDataProps={{
          approvedByColName: "Marked by",
          confirmedByColName: "Approved by",
        }}
        onClose={handleCloseWebApprovedModal}
      /> */}

      {/* <VideoTitlingBaseModalTable
        headerTitle="Revised titles"
        open={openRevisedTitleModal}
        enable={openRevisedTitleModal}
        onClose={handleCloseRevisedTitleModal}
        dataProps={{
          hideReadyForTitling: true,
        }}
      /> */}
      <DashboardTitledRevisedModal
        headerTitle="Revised titles"
        open={openRevisedTitleModal}
        enable={openRevisedTitleModal}
        onClose={handleCloseRevisedTitleModal}
        dataProps={{
          hideReadyForTitling: true,
        }}
      />
      <DashBoardRevisedTitlesPendingModal
        headerTitle="Revised titles"
        open={openPendingRevisionModal}
        enable={openPendingRevisionModal}
        filterRowProps={{
          hideLastItem: true,
          rightItems: (
            <>
              <Button className={styles.pendingBtn}>Pending Revision</Button>
            </>
          ),
        }}
        onClose={handleClosePendingRevisionModal}
      />
      {/* <VideoTitlingBaseModalTable
        headerTitle="Video pending publications"
        open={openPendingPublicationModal}
        onClose={handleClosePendingPublicationModal}
      /> */}
      <DashboardVideoPendingPublicationModal
        headerTitle="Videos pending publication"
        open={openPendingPublicationModal}
        enable={openPendingPublicationModal}
        onClose={handleClosePendingPublicationModal}
        filterRowProps={{
          hideLastItem: true,
        }}
      />

      {/* <AllPurchasedVideoModal
        open={openAllPurchasedVideoModal}
        onClose={handleCloseAllPurchasedVideoModal}
      /> */}
      <PurchasedVideoModal
        open={openAllPurchasedVideoModal}
        value={value}
        setValue={setValue}
        onClose={handleCloseAllPurchasedVideoModal}
      />
      <InvitationModal
        refetch={refetch}
        invitationData={invitationData}
        open={openInvitationModal}
        onClose={handleCloseInvitationModal}
      />
      <GalleryModal
        open={openedGalleryModal}
        onClose={handleCloseGalleryModal}
      />
    </Wrapper>
  );
}
